/**
    商品列表
**/
<template>
  <div class="rightaside_content"  v-loading='loading'>
    <el-row :gutter="20">
      <el-col :span="16">
           <div class="ownerInfo">
                <div class="ownerInfo_left">
                   <el-image class="avartarImg" :src="info.avatar?info.avatar:userImg.avatar">
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="ownerInfo_right">
                     <span style="font-size:18px">{{info.nickname}}</span>
                     <p style="color: #757575;margin-bottom:15px">{{ info.signature&&info.signature!='null'?info.signature:'' }}</p>
                      <router-link :to="`/userCenter`"><p style="color: #ff6700;">修改个人信息</p></router-link>
                </div>
          </div>
      </el-col>      
      <el-col class="phoneInfo" :span="8">
          <p>绑定手机：{{info.photo!=null&&info.photo!=''?encryption(info.photo,4):'未填写'}}</p>
          <p>绑定邮箱：{{info.email!=null&&info.email!=''?encryption(info.email,1):'未填写'}}</p>
          <p>企业审核：{{info.verify!=null?verifyType(info.verify):'未填写'}} <span v-if="info.refuseReason">（{{info.refuseReason}}）
		  </span></p>
      </el-col>
      <el-col :span="24">
        <el-divider></el-divider>
      </el-col>
    </el-row>
    <el-row>
        <el-col :span="12">
            <div class="ownerInfo ownerInfoBox">
                <div class="ownerInfo_left">
                    <el-image class="avartarImgBox" :src="require('@/assets/img/pay.png')">
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="ownerInfo_right">
                     <span style="font-size:18px">待支付的订单：<i style="color: #ff6700;">{{info.wait_Pay}}</i></span>
                    <router-link :to="`/myOrderRight?tap=1`"><p style="color: #666;">查看待支付订单 <i class="el-icon-arrow-right"></i></p></router-link>
                </div>
          </div>
        </el-col>
        <el-col :span="12">
            <div class="ownerInfo ownerInfoBox">
                <div class="ownerInfo_left">
                    <el-image class="avartarImgBox" :src="require('@/assets/img/send.png')">
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="ownerInfo_right">
                     <span style="font-size:18px">待收货的订单：<i style="color: #ff6700;">{{info.wait_take_Goods}}</i></span>
                    <router-link :to="`/myOrderRight?tap=3`"><p style="color: #666;">查看待收货订单 <i class="el-icon-arrow-right"></i></p></router-link>
                </div>
          </div>
        </el-col>
         <el-col :span="12">
            <div class="ownerInfo ownerInfoBox">
                <div class="ownerInfo_left">
                    <el-image class="avartarImgBox" :src="require('@/assets/img/pingjia.png')">
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="ownerInfo_right">
                     <span style="font-size:18px">待评价商品数：<i style="color: #ff6700;">{{info.wait_appraise_Goods}}</i></span>
                    <router-link :to="`/goodsAppraisal?tap=1`"><p style="color: #666;">查看待评价商品 <i class="el-icon-arrow-right"></i></p></router-link>
                </div>
          </div>
        </el-col>
         <el-col :span="12">
            <div class="ownerInfo ownerInfoBox">
                <div class="ownerInfo_left">
                    <el-image class="avartarImgBox" :src="require('@/assets/img/like.png')">
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <div class="ownerInfo_right">
                     <span style="font-size:18px">喜欢的商品：<i style="color: #ff6700;">{{info.like_Goods}}</i></span>
                    <router-link :to="`/goodsCollection`"><p style="color: #666;">查看喜欢的商品 <i class="el-icon-arrow-right"></i></p></router-link>
                </div>
          </div>
        </el-col>
    </el-row>   
  </div>
</template>
<script>
import { userDetails } from "@/api/xunyou";
import { mapState,mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(['userImg']),
  },
  data() {
    return {
         userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        loading:false,
    info:{
        id: 1,
        name: "xunyou测试员",
        time: "2020-10-20 00:12:23",
        tag: "非常好，非常好",
        avatar: require("@/assets/images/commend1.jpg"),
        phone:'13123455463',
        email:'11111eee@qq.com',
        waitPayOrder:27,
        waitReceiptOrder:2,
        waitAssess:1,
        likeGoods:1,
		verify:0,   			//审核状态-0:未审核,1:审核未通过,2:审核通过
		refuseReason:'',        //拒绝原因
      },
    };
  },
 // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
      this.getuserDetails()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       //  个人信息加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 3);
        var newStrs = str.substring(str.length , str.length - 4);
        newStr = newStr + "****" + newStrs;
        return newStr;
      }
    },
 //  审核状态转换
    verifyType(num) {
		console.log(num);
		let y = '';
		switch(num){
			case 0:y = "未审核";
			break;
			case 1:y ="未通过";
			break;
			case 2:y ="通过";
			break;
			y ="未审核";
		}
		  return y;
    },
    // 查询我的信息
    getuserDetails() {
      this.loading = true;
      const req ={
        userId:this.userInfo.userId,
      }
      userDetails(req)
        .then((res) => {
          if(res.code == 0){
              console.log(res,'查询我的信息')
            this.loading = false
            this.info=res.data
          }
        })
        .catch((err) => {
          this.$message.error("查询我的信息失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
    padding: 30px 0;
    box-sizing: border-box;
    .ownerInfo{
        display: flex;
        .ownerInfo_left{
            margin-right: 20px;
            .avartarImg{
                width: 150px;
                height: 150px;
                border-radius: 50%;
            }
            .avartarImgBox{
                width: 90px;
                height: 90px;
                border-radius: 50%;
            }
        }
        .ownerInfo_right{
            position: relative;
            transform: translate(0, 25%);
        }
    }
    .ownerInfo.ownerInfoBox {
        margin-bottom: 30px;
    }   
    .phoneInfo {
        position: relative;
        transform: translate(0, 30%);
        font-size: 14px;
        line-height: 26px;
        color: #908a8a;
    }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/myCenter/myInfo.vue